import React, { memo } from "react";
import styled from "styled-components";
import DateSelector from "./date_selector";

const LessonOpenDatePickerContainer = styled.div``;

const LessonOpenDatePickerTitle = styled.h3`
  color: #1e1e1e;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
`;

const DateAndTimeSelectorContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 8px;
`;

const LessonOpenDatePicker = () => {
  return (
    <LessonOpenDatePickerContainer>
      <LessonOpenDatePickerTitle>Дата/время</LessonOpenDatePickerTitle>
      <DateAndTimeSelectorContainer>
        <DateSelector />
      </DateAndTimeSelectorContainer>
    </LessonOpenDatePickerContainer>
  );
};

export default memo(LessonOpenDatePicker);
